import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { HeaderTemplate, KeyValue, Stepper, TitleHeader } from 'web-library';
import { useGetGroupWithdrawalSummary } from '../../../api/candidate/exam/@coordinator/queries-services/queries';
import WithdrawalReason from '../../../modules/withdrawal/components/coordinator/WithdrawalReason';

const WithdrawalReasonPage = ({ routeSteps }: { routeSteps: { label: string }[] }) => {
  const { t } = useTranslation();
  const { uuid } = useParams<{ uuid: string }>();

  const { data: summaryResponse } = useGetGroupWithdrawalSummary(uuid);

  return (
    <>
      <TitleHeader title={t('withdrawal->>Coordinator.Header.TitleHeader')} />
      {summaryResponse && (
        <>
          <HeaderTemplate>
            <KeyValue
              keyText={t('withdrawal->>Coordinator.Header.ExamLevel')}
              valueText={summaryResponse.examType?.description}
            />
            <Stepper activeStep={0} steps={routeSteps} />
          </HeaderTemplate>
          <WithdrawalReason
            examTypeCode={summaryResponse.examType.code}
            lastUpdatedTime={summaryResponse.lastUpdatedTime}
          />
        </>
      )}
    </>
  );
};

export default WithdrawalReasonPage;
